export default {
  // Titles
  verificationResult: "Verification Result",
  modelVerification: "Model Verification",

  // Verification Statistics
  currentSuccess: "Current {count} verified successfully;",
  hasFailed: "{count} verification failed;",
  hasNoNeed:
    "{count} are platform addresses that do not require model verification.",

  // No Data
  noData: "No Data",

  // Loading
  loading: "Loading...",

  // Basic Information
  basicInfo: "Basic Information",
  caseName: "Case Name",
  canvasName: "Canvas Name",
  creator: "Creator",
  createTime: "Create Time",
  status: "Status",
  verified: "Verified",
  toBeVerified: "To Be Verified",
  model: "Model",
  feeModel: "Fee Model",

  // Verification Result Details
  verificationResultTitle: "Verification Result",
  firstFeeSourcePlatform: "First Fee Source Platform",
  firstFeeSourceLevel: "First Fee Source Level",
  feeSourceLevel: "Fee Source Level",
  firstFeeSourceQuantity: "First Fee Source Quantity",
  firstFeeSourceTime: "First Fee Source Time",
  firstFeeSourceAddress: "First Fee Source Address",
  feeSourceAddress: "Fee Source Address",
  firstFeeSourceHash: "First Fee Source Hash",
  feeSourceHash: "Fee Source Hash",
  feeSourceTime: "Fee Source Time",
  feeSourceQuantity: "Fee Source Quantity",

  // Operations
  addToSurvey: "+Add to Survey",
  addToSurveySuccess: "Added to survey successfully!",
  copySuccess: "Copied successfully",
  browserNotSupport: "This browser does not support automatic copying",
};
